module.exports = __webpack_public_path__ + "img/stu-banner_bak.450509e8.jpg";